import * as React from 'react';
import { IMicrositeRecipient, IMicrositeRecipientCoachLogEntry, IMicrositeRecipientForList } from '@nkr/models/index';
import { Accordion, Button, Panel } from 'react-bootstrap';
import ConfirmDeleteEntry from './confirm-delete-entry';
import AddEditEntry from './add-edit-entry';
import LogEntry from './log-entry';

interface IProps {
    data: IMicrositeRecipientForList|IMicrositeRecipient,
    onSaveCoachLogEntry: (id: number, micrositeRecipientId: number, content: string,  actionType: number, isPinned: boolean) => void,
    onDeleteLogEntry: (id: number, micrositeRecipientId: number) => void
}

interface IState {
    entry: {
        show: boolean,
        data: IMicrositeRecipientCoachLogEntry
    },
    deleteEntry: {
        show: boolean,
        data: IMicrositeRecipientCoachLogEntry
    }
}

class AuditLog extends React.Component<IProps, IState> {
    readonly state: IState = {
        entry: {
            show: false,
            data: null
        },
        deleteEntry: {
            show: false,
            data: null
        }
    }

    handleAddEntry = () => {
        this.setState({
            entry: {
                show: true,
                data: null
            }
        });
    }

    handleEditEntry = (id: number) => {
        let data = this.props.data.coachLogEntries?.find(x => x.id == id);

        this.setState({
            entry: {
                show: true,
                data
            }
        });
    }

    handleCancelEntry = () => {
        this.setState({
            entry: {
                show: false,
                data: null
            }
        });
    }

    handleSaveEntry = (content: string, actionType: number, isPinned: boolean) => {
        let id = this.state.entry.data != null ? this.state.entry.data.id : 0;

        this.setState({
            entry: { ...this.state.entry, show: false }
        }, () => {
            this.props.onSaveCoachLogEntry(id, this.props.data.id, content, actionType, isPinned);
        });
    }

    handleConfirmDeleteEntry = (id: number) => {
        let data = this.props.data.coachLogEntries?.find(x => x.id == id);

        this.setState({
            deleteEntry: {
                show: true,
                data
            }
        });
    }

    handleCancelDeleteEntry = () => {
        this.setState({
            deleteEntry: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteEntry = () => {
        let id = this.state.deleteEntry.data.id;

        this.setState({
            deleteEntry: {
                show: false,
                data: null
            }
        }, () => {
            this.props.onDeleteLogEntry(id, this.props.data.id);
        });
    }

    sortFun = (a:IMicrositeRecipientCoachLogEntry, b:IMicrositeRecipientCoachLogEntry) => {
        // Pinned items come first
        if (a.isPinned && !b.isPinned) return -1;
        if (!a.isPinned && b.isPinned) return 1;

        // If both are pinned or both are not pinned, sort by logDateTime descending
        const da = Date.parse(a.logDateTime);
        const db = Date.parse(b.logDateTime);
        return db - da;
    }

    render = () => {
        return (
            <>
                <Accordion>
                    <Panel style={{maxHeight: '450px', overflowY: 'auto'}}>
                        <Panel.Heading>
                            <Panel.Toggle componentClass="div" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <Panel.Title>Coach Notes</Panel.Title>
                                <Button 
                                    bsStyle='link' 
                                    style={{ padding: 0 }} 
                                    disabled={this.state.entry.show}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!this.state.entry.show) {
                                            this.handleAddEntry();
                                        }
                                    }}
                                >
                                    Add Log Entry
                                </Button>
                            </Panel.Toggle>
                        </Panel.Heading>

                        <Panel.Collapse>
                            <Panel.Body style={{ minHeight: 200 }}>
                                {this.state.entry.show && (
                                    <AddEditEntry
                                        data={this.state.entry.data}
                                        onSave={this.handleSaveEntry}
                                        onCancel={this.handleCancelEntry}
                                    />
                                )}

                                {this.props.data.coachLogEntries?.sort(this.sortFun).map((entry, index) =>
                                    
                                    <LogEntry
                                        key={entry.id}
                                        data={entry}
                                        onEdit={this.handleEditEntry}
                                        onConfirmDelete={this.handleConfirmDeleteEntry}
                                    />
                                )}

                                {this.props.data.coachLogEntries?.length == 0 && this.state.entry.show == false && (
                                    <div>No log entries... click <a style={{ cursor: 'pointer' }} onClick={this.handleAddEntry}>Add Log Entry</a> to start...</div>
                                )}
                            </Panel.Body>
                        </Panel.Collapse>
                    </Panel>
                </Accordion>

                <ConfirmDeleteEntry
                    show={this.state.deleteEntry.show}
                    data={this.state.deleteEntry.data}
                    onDelete={this.handleDeleteEntry}
                    onCancel={this.handleCancelDeleteEntry}
                />
            </>
        );
    }
}

export default AuditLog;